// main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { installSessionSync } from './features/auth/sessionSync';
import { registerServiceWorker } from './utils/registerServiceWorker';
import FontAwesomeIcon from './plugins/fontawesome'; // Import fontawesome.js

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import './global.css';
import { hanFilter } from './utils/hanSearch';

// 所有表格與下拉選單的內建搜尋都繁簡互通
const hanFilterDefaults = { customFilter: hanFilter };
const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    VAutocomplete: hanFilterDefaults,
    VCombobox: hanFilterDefaults,
    VDataIterator: hanFilterDefaults,
    VDataTable: hanFilterDefaults,
    VDataTableVirtual: hanFilterDefaults,
  },
});

function bootstrap() {
  const app = createApp(App);
  app.use(router);
  app.use(store);
  app.use(vuetify);
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.mount('#app');
  installSessionSync({ store });
  // skipAuthRedirect: this boot-time probe runs on every page load
  // regardless of route (including public/unknown paths); its 401s must
  // not override the router's own decision about whether the current
  // route needs auth (e.g. it was clobbering NotFound.vue for anonymous
  // users hitting an unknown URL). Routes that do need auth still get
  // redirected to /login by the router guard itself (see router/index.js).
  store.dispatch('restoreSession', { skipAuthRedirect: true });
}

bootstrap();
registerServiceWorker();
